import { type FC } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import PeopleIcon from "@mui/icons-material/People";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { AnalyticsMetrics } from "@/partner/shared/components/AnalyticsMetrics";
import { formatNumber } from "@/shared/utils/formatNumber";
import { formatDuration } from "@/shared/utils/formatDuration";
import { useAnalyticsViewsMetricsQuery } from "@/partner/entities/analytics";

export const AnalyticsViewsMetrics: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  const { data, loading, error } = useAnalyticsViewsMetricsQuery({
    fetchPolicy: "no-cache",
    variables: { filter: filter as never },
  });

  const metrics = [
    {
      icon: VisibilityIcon,
      label: t("analytics.views.metricsViews"),
      value: formatNumber(data?.analyticsViews.views ?? 0),
    },
    {
      icon: PeopleIcon,
      label: t("analytics.views.metricsVisitors"),
      value: formatNumber(data?.analyticsViews.visitors ?? 0),
    },
    {
      icon: AccessTimeIcon,
      label: t("analytics.views.metricsDuration"),
      value: formatDuration(data?.analyticsViews.duration ?? 0) ?? "",
    },
  ];

  return (
    <AnalyticsMetrics
      metrics={metrics}
      loading={loading}
      error={error}
      xs={12}
      md={4}
    />
  );
};
